import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL + '/api/tunjangan-karyawan';

export const fetchTunjangan = async () => {
  try {
    const response = await axios.get(BASE_URL);
    if(response.data.status) {
      return response.data.data;
    }
    throw new Error('Gagal mengambil data tunjangan');
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const createTunjangan = async (payload) => {
  try {
    const response = await axios.post(BASE_URL, payload);
    return response.data;
  } catch (error) {
    console.error('Create failed:', error);
    throw error;
  }
};

export const updateTunjangan = async (id, payload) => {
  try {
    const response = await axios.put(`${BASE_URL}/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Update failed:', error);
    throw error;
  }
};

export const deleteTunjangan = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Delete failed:', error);
    throw error;
  }
};